import {cabecalhos} from "./Cabecalhos";
import {formatarValor, formatarValorMonetario} from "../../../helpers";

export const formatarLinhaDetalhamentoProduto = linha => {
  for (const cabecalho of cabecalhos) {
    if (cabecalho.dinheiro) {
      linha[cabecalho.value] = formatarValorMonetario(linha[cabecalho.value]);
    } else if (cabecalho.numero) {
      linha[cabecalho.value] = formatarValor(linha[cabecalho.value]);
    }

    if (`${linha[cabecalho.value] || ''}`.trim() === '') {
      linha[cabecalho.value] = '-';
    }

    if (cabecalho.append) {
      linha[cabecalho.value] = `${linha[cabecalho.value]} ${cabecalho.append}`;
    }
  }

  return linha;
};
